import { apiClientWithRefreshToken } from "@/api/apiClient";

export default async function DeleteSupplier(id: string): Promise<void> {
    await apiClientWithRefreshToken({
        url: `/suppliers/${id}`,
        method: "DELETE",
    });
}
